// extracted by mini-css-extract-plugin
export var footer = "_nl-5";
export var fulfillmentInput = "_nl-0";
export var shipDateInput = "_nl-1";
export var shipmentModal = "_nl-2";
export var shipmentModalContent = "_nl-3";
export var tableContainer = "_nl-4";